








































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import StatusPanel from '@/components/StatusPanel.vue';
import BaseInfoPanel from '@/components/BaseInfoPanel.vue';
import { PaginationPanel } from '@/components';
import collapse from '../../../utils/collapse.js';
import publicFunc from '../../../common/util/publicFunc';
import { PayApi, ExpenseType } from '@/http';
import { type } from '@/http/interface';
import { enums } from '@/common/enums';
import { formRules } from '@/common/util/validator';

export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        StatusPanel,
        BaseInfoPanel,
    },
})
export default class AddBill extends Vue {
    public $refs: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        basicForm: HTMLFormElement;
    };
    public title: string = '添加待对账费用';
    // 验证规则
    public formRules = formRules;
    public publicFunc: any = publicFunc;
    public receiptStatusEnum = enums.receiptStatusEnum;
    public waybillStatusEnum = enums.wayBillStatusType;
    public labelPosition: string = 'right';
    public isCost: boolean = true;
    public dialogVisible: boolean = false;
    public payTitle: string = '';

    public expandType: boolean = false;
    public loading = false;
    public rePagin = false;
    public total = 0;
    public isActive: boolean = false;
    public tableData = [];
    public billId: string = '';
    public firstDepartmentName: string = '';
    mounted() {
        this.billId = String(this.$route.query.id);
    }
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        // sessionStorage.setItem('SingleInquiry_page', JSON.stringify(pagin));
        this.loadApprovedFeeList();
    }
    public timeList = [];
    public datetimerange(value) {
        if (value) {
            this.searchValue.startDeliveryTime = value[0];
            this.searchValue.endDeliveryTime = value[1];
        } else {
            this.searchValue.startDeliveryTime = null;
            this.searchValue.endDeliveryTime = null;
        }
    }
    public searchValue: any = {
        carrierOrderCode: '',
        shipOrderNo: '',
        feeType: '',
        receiptStatus: '',
        startDeliveryTime: '',
        endDeliveryTime: '',
        carrierId: '',
        billId:'',
        asc: true,
        orderBy: '',
    };
    //费用查询
    public searchFunc() {
        // sessionStorage.setItem('SingleInquiry_searchValue', JSON.stringify(this.searchValue));
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }
    //费用重置
    public resetSearchValue() {
        this.searchValue = {
            carrierOrderCode: '',
            shipOrderNo: '',
            feeType: '',
            receiptStatus: '',
            startDeliveryTime: '',
            endDeliveryTime: '',
            carrierId: '',
            billId: this.billId,
            asc: true,
            orderBy: '',
        };
        this.timeList = [];
        this.loadApprovedFeeList();
    }
  

    /**
     * 获取费用类型
     */
    public feeTypeList = [];
    public async GetfeeTypeList() {
        await ExpenseType.GetList({
            isEnable: true,
            skip: -1,
            count: -1,
        }).then((res) => {
            this.feeTypeList = res.data;
        });
    }
    /**
     * 获取已审核费用
     */
    public feeTableData = [];
    public feeTotal: number = 0;
    public async loadApprovedFeeList() {
        this.searchValue.billId = this.billId;
        this.loading = true;
        await PayApi.Getfeelist({
            ...this.searchValue,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        })
            .then((res) => {
                this.tableData = res.data;
                let skip = this.searchPagin.skip;
                this.tableData.map((item, index) => {
                    item.index = skip++ + 1;
                });
                this.total = res.total;
                this.loading = false;
                this.$refs.pagination.setPage(this.searchPagin.currentPage);
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    public id: string = '';
    public open(value) {
        // this.searchValue.feeStatus = '';
        // this.searchValue.carrierId = value;
        this.id = value;
        this.searchValue.isAddToBillPage = true;
        this.GetfeeTypeList();
        this.loadApprovedFeeList();
        this.dialogVisible = true;
    }
    /**
     * 添加待对账费用至账单
     */
    submit(row) {
        this.$confirm('确认添加至账单?', '提示', {
            type: 'warning',
        }).then(async () => {
           PayApi.AddFeeToBill({feeId:row.id,billId:this.id}).then(res=>{
                 this.$message.success('添加至账单成功！');
                    this.dialogVisible = false;
                    this.$emit('reload');
                    this.$emit('reloadBasic');
           }).catch(e=>{
               this.$message.error('添加至账单失败！');
           })
        });
    }
    public formClose() {
        this.dialogVisible = false;
    }
    public back() {
        this.$router.push({
            path: '/costStatement',
        });
    }
    public getcarriageWayColor(val) {
        switch (val) {
            case '待派车':
                return 'c_yellow';
            case '待发货':
                return 'c_yellow';
            case '在途中':
                return 'c_blue';
            case '已送达':
                return 'c_green';
            case '已终结':
                return 'c_red';

            default:
                break;
        }
    }
    public getBillColor(val) {
        switch (val) {
            case '待提交':
                return 'c_blue';
            case '待审核':
                return 'c_yellow';
            case '审核退回':
                return 'c_red';
            case '已审核':
                return 'c_green';

            default:
                break;
        }
    }
    public getCostColor(val) {
        switch (val) {
            case '待审核':
                return 'c_yellow';
            case '审核退回':
                return 'c_red';
            case '已审核':
                return 'c_green';
            case '不通过':
                return 'c_gray';

            default:
                break;
        }
    }
    public toSkip(row, type) {
        if (type == 1) {
            this.$router.push({
                path: '/WayBillDetail',
                query: {
                    orderId: row.carrierOrderId,
                    type: 'fee',
                    fee: '3',
                    feeId: this.billId,
                },
            });
        }
    }

    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            //给每一行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'carrierOrderCode':
                {
                    this.searchValue.orderBy = '1';
                }
                break;
            case 'deliveryTime':
                {
                    this.searchValue.orderBy = '2';
                }
                break;
            case 'carrierOrderStatusStr':
                {
                    this.searchValue.orderBy = '3';
                }
                break;
        }
        this.loadApprovedFeeList();
    }
}
